import BaseApi from '../BaseApi'

class DemoApi extends BaseApi {
  getToken = () => this.sendQuery(this.queryTypes.POST, `/api/session/open`, {}, { headers: { 'Token': '1040413e58cbcfac6500fe37a3ead8f' } })
}

export default DemoApi
